import React from "react";
import { useAppSelector } from "../../store/hooks";

/**
 * TickerBar — XT-style fixed bottom strip of live pair prices.
 * Desktop only (mobile uses the bottom nav). Reads from the price store,
 * so it updates with the same WebSocket/REST feed as the rest of the app.
 */
const TickerBar: React.FC = () => {
  const marketData = useAppSelector((s) => s.prices.marketData);
  const entries = Object.values(marketData || {});

  if (!entries.length) return null;

  return (
    <div className="hidden md:flex fixed bottom-0 left-0 right-0 h-7 bg-card border-t border-gray-700 z-30 items-center px-3 gap-5 overflow-x-auto whitespace-nowrap text-[11px] font-mono">
      {entries.map((m) => {
        const up = (m.change_24h ?? 0) >= 0;
        return (
          <span key={m.symbol} className="flex items-center gap-1.5 shrink-0">
            <span className="text-gray-50 font-semibold">
              {m.symbol}/USDT
            </span>
            <span className={up ? "text-up" : "text-down"}>
              {up ? "+" : ""}
              {(m.change_24h ?? 0).toFixed(2)}%
            </span>
            <span className="text-gray-400">
              {m.price >= 1 ? m.price.toLocaleString() : m.price}
            </span>
          </span>
        );
      })}
    </div>
  );
};

export default TickerBar;
